import { ChangeEvent, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { showNotification } from '@/utils/notificationUtils';
import { useUpdatePassword } from '../api/updatePassword';
import { PetskedTitle } from '@/components/Heading/PetskedTitle';
import './UpdatePassword.scss';
import { Loader } from '@/components/Loader/Loader';
export const UpdatePassword = () => {
  const navigate = useNavigate();
  const search = useLocation().search;
  const token = new URLSearchParams(search).get('token');
  const updatePasswordMutation = useUpdatePassword();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (event.target.id === 'password') {
      setPassword(event.target.value);
    } else if (event.target.id === 'confirmpassword') {
      setConfirmPassword(event.target.value);
    }
  };
  const validate = () => {
    if (!password) {
      showNotification({
        type: 'info',
        title: 'Please enter password',
      });
      return false;
    } else if (!confirmPassword || password != confirmPassword) {
      showNotification({
        type: 'info',
        title: 'Password not matched',
      });
      return false;
    }
    return true;
  };
  const onResetPassword = async () => {
    if (validate()) {
      await updatePasswordMutation.mutateAsync({
        password,
        confirmPassword,
        token,
      });
      navigate('/shops');
    }
  };
  return (
    <section className="petsked-container-bg reset-password">
      <PetskedTitle
        title="Reset"
        highlightTitle="password"
        size="lg"
        alignText="center"
        description=""
      />
      <div className={`details`}>
        <div className="calender-row-center">
          <div className="petsked-form">
            <div className="form-field">
              <input
                id="password"
                type="password"
                value={password}
                className="cust-input-mobile"
                onChange={handleChange}
                placeholder="Enter your password"
              />
            </div>
            <div className="form-field">
              <input
                id="confirmpassword"
                type="password"
                value={confirmPassword}
                className="cust-input-mobile"
                onChange={handleChange}
                placeholder="Confirm password"
              />
            </div>
            <div className="action">
              <button
                className="petsked-button button-dark"
                onClick={onResetPassword}
                disabled={updatePasswordMutation.isLoading}
              >
                {updatePasswordMutation.isLoading ? <Loader /> : <span>Update</span>}
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
